/* eslint-disable import/prefer-default-export */
export const formatToJson = (obj) => {
  const output = Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string') {
        try {
          return [key, JSON.parse(value)];
        } catch {
          return [key, value];
        }
      }
      return [key, value];
    })
  );

  return output;
};
